<template>
  <div class="results">
    <div class="results-separator" v-if="products.length > 0">
      <div>{{labels.results}}</div>
       <FlatButton :label="labels.changeFilters" @click="onBack()" blue></FlatButton>
    </div>
    <div class="product-container" v-if="products.length > 0">
      <Product v-for="item in products" :product="item" :key="item.id"  >
      </Product>
    </div>
  </div>
</template>

<script>
import Product from "./Product.vue";
import { FlatButton } from "clariant-vue-forms";
import {Labels} from "../services";

export default {
  name: 'Results',
  props: [
    "products"
  ],
  data () {
    return {
      labels: Labels
    }
  },
  components: {
    Product,
    FlatButton
  },
  mounted() {
    setTimeout(() => {
      console.log("Triggering dom changed.");
      jQuery(cla).triggerHandler( "domchanged", ".results" );
    });
  },
  methods: {
    onBack: function () {
      this.$emit("click");
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .results-separator {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 2px -2px #bbb;
    outline: none;
    margin-bottom: 20px;
    height:54px;
  }
  .results-separator > div {
    font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
      font-weight: 700;
      font-size: 18px;
      color: black;
  }
</style>
